import React from "react";
import RandomPhoto from "./RandomPhoto/RandomPhoto";
import classes from "./Photowall.module.css";
import wordmark from '../../../assets/wordmarks/Dickinson_RED_PMS186.png';

const PhotoWall = (props) => {
  const photos = Array.from({ length: 12 }, (_, k) => <RandomPhoto key={k} />);

  return (
    <div className={classes.PhotoWall}>
      <div
        className={classes.PhotoWallPhotos}
        aria-hidden="true"
      >
        {photos}
      </div>
      <div className={classes.PhotoWallCta}>
        <div className={classes.PhotoWallContent}>
          <div className={classes.Logo}>
            {/* <h1 className="kepler crimson-text">Dickinson</h1> */}
            <img src={wordmark} alt="Dickinson" />
            <div className={classes.SubLogo}>
              <h2>GLOBAL.</h2>
              <h2>SUSTAINABLE.</h2>
              <h2>ENGAGED.</h2>
            </div>
          </div>
          <div className={classes.Quote}>
            <p>“PIETATE ET DOCTRINA TUTA LIBERTAS.”</p>
            <p>Revolutionary since 1783.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhotoWall;
